import * as React from "react";
import { IEpiserverContext } from 'features/core/types';

export default React.createContext<IEpiserverContext | null>(null);
